export const MOCK_ORDER_DETAILS = {
  entity: {
    billing_first_name: 'Max',
    billing_last_name: 'Spark',
    billing_phone: '012341234123',
    billing_email: 'maxspark360@gmail.com',
    source: {
      title: 'Journey: Commodity: Strom (Neukunde)',
      href: '/app/journey-builder/journeys/74dacb80-112a-11f0-bc7b-f59f0d1cc396'
    },
    journey_data: {
      'Umzug - Ablesedatum': {
        startDate: '2025-04-01',
        endDate: null,
        _isValid: true
      },
      'Umzug - Einzugsdatum': {
        startDate: '2025-04-01',
        endDate: null,
        _isValid: true
      },
      Verfügbarkeitsprüfung: {
        countryCode: 'DE',
        city: 'Köln',
        zipCode: '50670',
        streetName: 'Adolf-Fischer-Str.',
        streetNumber: '2',
        _isValid: true
      },
      Belieferung: 'Umzug',
      'Umzug - Zählerstand': {
        numberInput: '1245',
        numberUnit: 'kwh',
        _isValid: true
      },
      Stromverbrauch: {
        numberInput: '3000',
        numberUnit: 'kwh',
        frequencyUnit: 'yearly',
        _isValid: true
      },
      'Umzug - Zählernummer': '1APA0186583430',
      'Rechnungsadresse stimmt mit Lieferadresse überein': true
    },
    consents: {
      Lieferbestätigung: {
        agreed: true,
        topic: 'Lieferbestätigung',
        text: 'Ich erteile dem Lieferanten den Auftrag, meinen gesamten Bedarf an Energie an die genannte Entnahmestelle zu liefern. Die Belieferung erfolgt außerhalb der Grundversorgung. Ihre Bestellung wird uns durch das Anklicken des Buttons „Jetzt kostenpflichtig bestellen“ übersandt. Der Vertrag kommt erst durch unsere Bestätigung in Textform, die spätestens 14 Tage nach Absendung des Auftrags zu erfolgen hat, unter Angabe des voraussichtlichen Lieferbeginns, zustande. Der tatsächliche Lieferbeginn hängt davon ab, dass alle für die Belieferung notwendigen Maßnahmen (Kündigung des bisherigen Liefervertrags etc.) erfolgt sind.',
        time: '2025-04-04T09:18:00.379Z'
      },
      _isValid: true,
      'Wertersatz bei Widerruf': {
        agreed: true,
        topic: 'Wertersatz bei Widerruf',
        text: 'Ich verlange ausdrücklich, dass die Energielieferung – soweit möglich – auch beginnen soll, wenn der Lieferbeginn vor Ablauf der **[Widerrufsfrist](www.epilot.cloud)** liegt. Für den Fall, dass ich mein Widerrufsrecht ausübe, schulde ich dem Lieferanten für die bis zum Widerruf gelieferte Energie gemäß § 357 a Abs. 2 BGB einen angemessenen Wertersatz.',
        time: '2025-04-04T09:18:03.018Z'
      },
      DATA_PRIVACY: {
        agreed: true,
        topic: 'DATA_PRIVACY',
        text: 'Hiermit bestätige ich, dass ich die **[Datenschutzerklärung und Nutzungsbestimmungen](www.epilot.cloud)**.',
        time: '2025-04-04T09:18:04.008Z'
      },
      GTC: {
        agreed: true,
        topic: 'GTC',
        text: 'Ich habe die **[Allgemeinen Geschäftsbedingungen (AGB)](www.epilot.cloud)** gelesen und akzeptiert. Die **[Widerrufsbelehrung](www.epilot.cloud)** habe ich zur Kenntnis genommen.',
        time: '2025-04-04T09:18:04.880Z'
      },
      CANCELLATION_POLICY: {
        agreed: true,
        topic: 'CANCELLATION_POLICY',
        text: 'Ich habe die **[Allgemeinen Geschäftsbedingungen (AGB)](www.epilot.cloud)** gelesen und akzeptiert. Die **[Widerrufsbelehrung](www.epilot.cloud)** habe ich zur Kenntnis genommen.',
        time: '2025-04-04T09:18:04.880Z'
      }
    },
    payment_method: [
      {
        type: 'payment_sepa',
        data: {
          consent: true,
          fullname: 'Max Spark',
          bic_number: 'INGDDEFFXXX',
          bank_name: 'ING-DiBa',
          iban: 'DE02500105170137075030'
        },
        label: 'SEPA Lastschrift',
        _isValid: true
      }
    ],
    delivery_address: {
      $relation_ref: [
        {
          _tags: [],
          path: 'address',
          _id: 'FQMknAReKWEmcTpj3Sr1V',
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
        }
      ]
    },
    billing_address: {
      $relation_ref: [
        {
          _tags: [],
          path: 'address',
          _id: 'FQMknAReKWEmcTpj3Sr1V',
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
        }
      ]
    },
    erwarteter_jahresverbrauch_in_kwh: '3000',
    belieferung: 'Umzug',
    einzugsdatum: '2025-04-01',
    zaehlernummer: '1APA0186583430',
    zaehlerstand_in_kwh: '1245',
    ablesedatum: '2025-04-01',
    _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
    currency: 'EUR',
    _files: {
      $relation: [
        {
          entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
        },
        {
          entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
        }
      ]
    },
    status: 'open_for_acceptance',
    source_id: '74dacb80-112a-11f0-bc7b-f59f0d1cc396',
    source_type: 'journey',
    additional_addresses: [],
    tags: [],
    metadata: [
      {
        key: '_origin',
        value: 'journey checkout'
      }
    ],
    _tags: ['Commodity', 'Strom', 'copy'],
    line_items: [
      {
        price_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
        product_id: '9e757988-e24d-47a3-b376-9985053c1e30',
        quantity: 1,
        description: 'Strom Flex',
        unit_amount: 0,
        unit_amount_decimal: '0.00',
        pricing_model: 'per_unit',
        item_components: [
          {
            price_id: 'fbfd2a6b-8937-4897-848a-f50e50e8e1c4',
            product_id: '9e757988-e24d-47a3-b376-9985053c1e30',
            quantity: 1,
            description: 'Arbeitspreis',
            unit_amount: 0,
            unit_amount_decimal: '0',
            pricing_model: 'tiered_volume',
            _price: {
              _id: 'fbfd2a6b-8937-4897-848a-f50e50e8e1c4',
              description: 'Arbeitspreis',
              internal_description: 'Arbeitspreis',
              pricing_model: 'tiered_volume',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              unit: 'kwh',
              active: true,
              type: 'recurring',
              billing_duration_unit: 'months',
              notice_time_unit: 'months',
              termination_time_unit: 'months',
              renewal_duration_unit: 'months',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              tiers: [
                {
                  up_to: 9799,
                  unit_amount: 13,
                  unit_amount_decimal: '0.1272',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                },
                {
                  up_to: 55199,
                  unit_amount: 12,
                  unit_amount_decimal: '0.1198',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                },
                {
                  up_to: 77999,
                  unit_amount: 12,
                  unit_amount_decimal: '0.1175',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                },
                {
                  up_to: null,
                  unit_amount: 12,
                  unit_amount_decimal: '0.1151',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                }
              ],
              variable_price: true,
              billing_period: 'monthly',
              _title: 'Arbeitspreis',
              _coupons: []
            },
            _product: {
              name: 'Strom Flex',
              internal_name: 'Dummy Strom Flex',
              type: 'product',
              active: true,
              description: 'Some description',
              feature: [
                {
                  _id: 'qorpTJ5ytdvAoPNqqpvUA',
                  _tags: [],
                  value: '',
                  feature: '100% Ökostrom'
                },
                {
                  _id: 'GZ6HbqnWhtkefI5X8ruv3',
                  _tags: [],
                  value: '',
                  feature: 'Erstlaufzeit bis 31.12.2025'
                }
              ],
              price_options: [
                {
                  _id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                  description: 'Strom Flex',
                  internal_description: 'Dummy Strom Flex',
                  pricing_model: 'per_unit',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  is_tax_inclusive: true,
                  price_display_in_journeys: 'show_price',
                  active: true,
                  type: 'one_time',
                  billing_duration_unit: 'months',
                  notice_time_unit: 'months',
                  termination_time_unit: 'months',
                  renewal_duration_unit: 'months',
                  is_composite_price: true,
                  price_components: [],
                  _tags: ['composite'],
                  _schema: 'price',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '161180'
                    }
                  ],
                  _created_at: '2025-04-09T06:54:58.800Z',
                  _updated_at: '2025-04-09T07:45:20.482Z',
                  billing_period: 'weekly',
                  _title: 'Strom Flex',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                    _tags: []
                  }
                }
              ],
              _id: '9e757988-e24d-47a3-b376-9985053c1e30',
              _title: 'Strom Flex',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            tiers_details: [
              {
                quantity: 0,
                unit_amount: 13,
                unit_amount_decimal: '0.1272',
                unit_amount_net: 11,
                unit_amount_gross: 13,
                amount_subtotal: 0,
                amount_total: 0,
                amount_tax: 0
              }
            ],
            unit_amount_gross: 13,
            unit_amount_net: 11,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0.106890756303',
            unit_amount_gross_decimal: '0.1272',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0',
            _coupons: []
          },
          {
            price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
            product_id: '9e757988-e24d-47a3-b376-9985053c1e30',
            quantity: 1,
            description: 'Grundpreis',
            unit_amount: 0,
            unit_amount_decimal: '0',
            pricing_model: 'tiered_volume',
            _price: {
              _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              _manifest: [
                '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                '50fb9921-3b0d-430a-9211-5b741e601008',
                '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                '4573c148-9fa1-4de8-bb05-964a01690789'
              ],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Grundpreis',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              pricing_model: 'tiered_volume',
              tax: [
                {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                }
              ],
              tiers: [],
              type: 'recurring',
              unit_amount: 1300,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '13',
              variable_price: true,
              billing_duration_amount: '',
              billing_duration_unit: null,
              billing_period: 'monthly',
              internal_description: 'Grundpreis',
              notice_time_amount: null,
              notice_time_unit: null,
              price_components: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              _title: 'Grundpreis',
              _coupons: []
            },
            _product: {
              name: 'Strom Flex',
              internal_name: 'Dummy Strom Flex',
              type: 'product',
              active: true,
              description: 'Some description',
              feature: [
                {
                  _id: 'qorpTJ5ytdvAoPNqqpvUA',
                  _tags: [],
                  value: '',
                  feature: '100% Ökostrom'
                },
                {
                  _id: 'GZ6HbqnWhtkefI5X8ruv3',
                  _tags: [],
                  value: '',
                  feature: 'Erstlaufzeit bis 31.12.2025'
                }
              ],
              price_options: [
                {
                  _id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                  description: 'Strom Flex',
                  internal_description: 'Dummy Strom Flex',
                  pricing_model: 'per_unit',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  is_tax_inclusive: true,
                  price_display_in_journeys: 'show_price',
                  active: true,
                  type: 'one_time',
                  billing_duration_unit: 'months',
                  notice_time_unit: 'months',
                  termination_time_unit: 'months',
                  renewal_duration_unit: 'months',
                  is_composite_price: true,
                  price_components: [],
                  _tags: ['composite'],
                  _schema: 'price',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '161180'
                    }
                  ],
                  _created_at: '2025-04-09T06:54:58.800Z',
                  _updated_at: '2025-04-09T07:45:20.482Z',
                  billing_period: 'weekly',
                  _title: 'Strom Flex',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                    _tags: []
                  }
                }
              ],
              _id: '9e757988-e24d-47a3-b376-9985053c1e30',
              _title: 'Strom Flex',
              _messages: {}
            },
            taxes: [
              {
                tax: {
                  _manifest: [
                    '956e9f44-0d8e-4d50-af85-e528fb130d64',
                    'fe5c6fa8-b702-40fa-9b74-a4619eceaae9',
                    '491a3f8c-4a5b-41f9-89bd-f4c1ad4ceec7',
                    '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                    '4573c148-9fa1-4de8-bb05-964a01690789'
                  ],
                  _schema: 'tax',
                  active: true,
                  description: '19%',
                  rate: '19',
                  region: 'DE',
                  type: 'VAT',
                  _id: '170d696a-611a-4627-a904-137741027989',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '140034'
                    }
                  ],
                  _created_at: '2025-04-04T07:09:29.464Z',
                  _updated_at: '2025-04-04T07:57:19.848Z',
                  _title: '19%',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  }
                },
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            tiers_details: [
              {
                quantity: 0,
                unit_amount: 0,
                unit_amount_decimal: '0',
                unit_amount_net: 0,
                unit_amount_gross: 0,
                amount_subtotal: 0,
                amount_total: 0,
                amount_tax: 0
              }
            ],
            unit_amount_gross: 0,
            unit_amount_net: 0,
            amount_subtotal: 0,
            amount_total: 0,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '0',
            unit_amount_gross_decimal: '0',
            amount_subtotal_decimal: '0',
            amount_total_decimal: '0',
            _coupons: []
          },
          {
            price_id: '265b52a7-12d3-43aa-81fc-31214dff7289',
            product_id: '9e757988-e24d-47a3-b376-9985053c1e30',
            quantity: 1,
            description: 'Pauschalgebühr',
            unit_amount: 0,
            unit_amount_decimal: '0',
            pricing_model: 'tiered_flatfee',
            _price: {
              _id: '265b52a7-12d3-43aa-81fc-31214dff7289',
              description: 'Flat fee',
              internal_description: 'Flat fee',
              pricing_model: 'tiered_flatfee',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              unit: 'kwh',
              active: true,
              type: 'recurring',
              billing_duration_amount: '1',
              billing_duration_unit: 'months',
              notice_time_unit: 'months',
              termination_time_unit: 'months',
              renewal_duration_unit: 'months',
              tiers: [
                {
                  up_to: 10000,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  flat_fee_amount: 1000,
                  flat_fee_amount_decimal: '10'
                },
                {
                  up_to: 20000,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  flat_fee_amount: 1500,
                  flat_fee_amount_decimal: '15'
                },
                {
                  up_to: null,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  flat_fee_amount: 2000,
                  flat_fee_amount_decimal: '20'
                }
              ],
              variable_price: true,
              billing_period: 'yearly',
              _title: 'Flat fee'
            },
            _product: {
              name: 'Strom Flex',
              internal_name: 'Dummy Strom Flex',
              type: 'product',
              active: true,
              description: 'Some description',
              feature: [
                {
                  _id: 'qorpTJ5ytdvAoPNqqpvUA',
                  _tags: [],
                  value: '',
                  feature: '100% Ökostrom'
                },
                {
                  _id: 'GZ6HbqnWhtkefI5X8ruv3',
                  _tags: [],
                  value: '',
                  feature: 'Erstlaufzeit bis 31.12.2025'
                }
              ],
              price_options: [
                {
                  _id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                  description: 'Strom Flex',
                  internal_description: 'Dummy Strom Flex',
                  pricing_model: 'per_unit',
                  unit_amount: 0,
                  unit_amount_currency: 'EUR',
                  unit_amount_decimal: '0.00',
                  is_tax_inclusive: true,
                  price_display_in_journeys: 'show_price',
                  active: true,
                  type: 'one_time',
                  billing_duration_unit: 'months',
                  notice_time_unit: 'months',
                  termination_time_unit: 'months',
                  renewal_duration_unit: 'months',
                  is_composite_price: true,
                  price_components: [],
                  _tags: ['composite'],
                  _schema: 'price',
                  _org: '16246022',
                  _owners: [
                    {
                      org_id: '16246022',
                      user_id: '161180'
                    }
                  ],
                  _created_at: '2025-04-09T06:54:58.800Z',
                  _updated_at: '2025-04-09T07:45:20.482Z',
                  billing_period: 'weekly',
                  _title: 'Strom Flex',
                  _acl: {
                    view: ['org_16246022'],
                    edit: ['org_16246022'],
                    delete: ['org_16246022']
                  },
                  $relation: {
                    entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                    _tags: []
                  }
                }
              ],
              _id: '9e757988-e24d-47a3-b376-9985053c1e30',
              _title: 'Strom Flex',
              _messages: {}
            },
            taxes: [
              {
                rate: 'nontaxable',
                rateValue: 0,
                amount: 0
              }
            ],
            type: 'recurring',
            billing_period: 'monthly',
            tiers_details: [
              {
                quantity: 0,
                unit_amount: 1000,
                unit_amount_decimal: '10',
                unit_amount_net: 1000,
                unit_amount_gross: 1000,
                amount_subtotal: 1000,
                amount_total: 1000,
                amount_tax: 0
              }
            ],
            unit_amount_gross: 1000,
            unit_amount_net: 1000,
            amount_subtotal: 1000,
            amount_total: 1000,
            amount_tax: 0,
            currency: 'EUR',
            is_tax_inclusive: true,
            unit_amount_net_decimal: '10',
            unit_amount_gross_decimal: '10',
            amount_subtotal_decimal: '10',
            amount_total_decimal: '10'
          }
        ],
        _price: {
          _id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
          description: 'Strom Flex',
          internal_description: 'Dummy Strom Flex',
          pricing_model: 'per_unit',
          unit_amount: 0,
          unit_amount_currency: 'EUR',
          unit_amount_decimal: '0.00',
          is_tax_inclusive: true,
          price_display_in_journeys: 'show_price',
          active: true,
          type: 'one_time',
          billing_duration_unit: 'months',
          notice_time_unit: 'months',
          termination_time_unit: 'months',
          renewal_duration_unit: 'months',
          is_composite_price: true,
          price_components: [
            {
              _id: 'fbfd2a6b-8937-4897-848a-f50e50e8e1c4',
              description: 'Arbeitspreis',
              internal_description: 'Arbeitspreis',
              pricing_model: 'tiered_volume',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              unit: 'kwh',
              active: true,
              type: 'recurring',
              billing_duration_unit: 'months',
              notice_time_unit: 'months',
              termination_time_unit: 'months',
              renewal_duration_unit: 'months',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              tiers: [
                {
                  up_to: 9799,
                  unit_amount: 13,
                  unit_amount_decimal: '0.1272',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                },
                {
                  up_to: 55199,
                  unit_amount: 12,
                  unit_amount_decimal: '0.1198',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                },
                {
                  up_to: 77999,
                  unit_amount: 12,
                  unit_amount_decimal: '0.1175',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                },
                {
                  up_to: null,
                  unit_amount: 12,
                  unit_amount_decimal: '0.1151',
                  flat_fee_amount: 0,
                  flat_fee_amount_decimal: '0'
                }
              ],
              variable_price: true,
              billing_period: 'monthly',
              _title: 'Arbeitspreis'
            },
            {
              _id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
              _manifest: [
                '3babbfe8-80a2-4e19-b9e6-3d6d4fa22730',
                '50fb9921-3b0d-430a-9211-5b741e601008',
                '6b9c4f65-8e12-4085-b99a-61a2bd2026d8',
                '4573c148-9fa1-4de8-bb05-964a01690789'
              ],
              _purpose: ['ea91a7f8-9ea6-4432-959e-ee45e1c0b650'],
              _tags: ['Commodity', 'Strom'],
              active: true,
              description: 'Grundpreis',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              pricing_model: 'tiered_volume',
              tax: {
                $relation: [
                  {
                    entity_id: '170d696a-611a-4627-a904-137741027989'
                  }
                ]
              },
              tiers: [],
              type: 'recurring',
              unit_amount: 1300,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '13',
              variable_price: true,
              billing_duration_amount: '',
              billing_duration_unit: null,
              billing_period: 'monthly',
              internal_description: 'Grundpreis',
              notice_time_amount: null,
              notice_time_unit: null,
              price_components: null,
              renewal_duration_amount: null,
              renewal_duration_unit: null,
              termination_time_amount: null,
              termination_time_unit: null,
              _title: 'Grundpreis'
            },
            {
              _id: '265b52a7-12d3-43aa-81fc-31214dff7289',
              description: 'Flat fee',
              internal_description: 'Flat fee',
              pricing_model: 'tiered_flatfee',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              unit: 'kwh',
              active: true,
              type: 'recurring',
              billing_duration_amount: '1',
              billing_duration_unit: 'months',
              notice_time_unit: 'months',
              termination_time_unit: 'months',
              renewal_duration_unit: 'months',
              tiers: [
                {
                  up_to: 10000,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  flat_fee_amount: 1000,
                  flat_fee_amount_decimal: '10'
                },
                {
                  up_to: 20000,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  flat_fee_amount: 1500,
                  flat_fee_amount_decimal: '15'
                },
                {
                  up_to: null,
                  unit_amount: 0,
                  unit_amount_decimal: '0',
                  flat_fee_amount: 2000,
                  flat_fee_amount_decimal: '20'
                }
              ],
              variable_price: true,
              billing_period: 'yearly',
              _title: 'Flat fee'
            }
          ],
          _tags: ['composite'],
          billing_period: 'weekly',
          _title: 'Strom Flex'
        },
        _product: {
          name: 'Strom Flex',
          internal_name: 'Dummy Strom Flex',
          type: 'product',
          active: true,
          description: 'Some description',
          feature: [
            {
              _id: 'qorpTJ5ytdvAoPNqqpvUA',
              _tags: [],
              value: '',
              feature: '100% Ökostrom'
            },
            {
              _id: 'GZ6HbqnWhtkefI5X8ruv3',
              _tags: [],
              value: '',
              feature: 'Erstlaufzeit bis 31.12.2025'
            }
          ],
          price_options: [
            {
              _id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
              description: 'Strom Flex',
              internal_description: 'Dummy Strom Flex',
              pricing_model: 'per_unit',
              unit_amount: 0,
              unit_amount_currency: 'EUR',
              unit_amount_decimal: '0.00',
              is_tax_inclusive: true,
              price_display_in_journeys: 'show_price',
              active: true,
              type: 'one_time',
              billing_duration_unit: 'months',
              notice_time_unit: 'months',
              termination_time_unit: 'months',
              renewal_duration_unit: 'months',
              is_composite_price: true,
              price_components: [],
              _tags: ['composite'],
              _schema: 'price',
              _org: '16246022',
              _owners: [
                {
                  org_id: '16246022',
                  user_id: '161180'
                }
              ],
              _created_at: '2025-04-09T06:54:58.800Z',
              _updated_at: '2025-04-09T07:45:20.482Z',
              billing_period: 'weekly',
              _title: 'Strom Flex',
              _acl: {
                view: ['org_16246022'],
                edit: ['org_16246022'],
                delete: ['org_16246022']
              },
              $relation: {
                entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
                _tags: []
              }
            }
          ],
          _id: '9e757988-e24d-47a3-b376-9985053c1e30',
          _title: 'Strom Flex',
          _messages: {}
        },
        price_mappings: [
          {
            price_id: 'fbfd2a6b-8937-4897-848a-f50e50e8e1c4',
            value: 0
          },
          {
            price_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
            value: 0
          },
          {
            price_id: '265b52a7-12d3-43aa-81fc-31214dff7289',
            value: 0
          }
        ],
        currency: 'EUR',
        amount_subtotal: 1000,
        amount_total: 1000,
        total_details: {
          amount_tax: 0,
          breakdown: {
            taxes: [
              {
                tax: {
                  _id: '170d696a-611a-4627-a904-137741027989',
                  type: 'VAT',
                  rate: '19'
                },
                amount: 0
              },
              {
                tax: {
                  rate: 0
                },
                amount: 0
              }
            ],
            recurrences: [
              {
                type: 'recurring',
                billing_period: 'monthly',
                unit_amount_gross: 1013,
                unit_amount_net: 1011,
                amount_subtotal: 1000,
                amount_total: 1000,
                amount_subtotal_decimal: '10',
                amount_total_decimal: '10',
                amount_tax: 0
              }
            ],
            recurrencesByTax: [
              {
                type: 'recurring',
                billing_period: 'monthly',
                amount_total: 0,
                amount_subtotal: 0,
                amount_tax: 0,
                tax: {
                  tax: {
                    _id: '170d696a-611a-4627-a904-137741027989',
                    type: 'VAT',
                    rate: '19'
                  },
                  amount: 0
                }
              },
              {
                type: 'recurring',
                billing_period: 'monthly',
                amount_total: 1000,
                amount_subtotal: 1000,
                amount_tax: 0,
                tax: {
                  tax: {
                    rate: 0
                  },
                  amount: 0
                }
              }
            ],
            cashbacks: []
          }
        },
        amount_tax: 0,
        amount_subtotal_decimal: '10',
        amount_total_decimal: '10'
      }
    ],
    prices: {
      $relation: [
        {
          entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
          _schema: 'price',
          _tags: []
        }
      ]
    },
    products: {
      $relation: [
        {
          entity_id: '9e757988-e24d-47a3-b376-9985053c1e30',
          _schema: 'product',
          _tags: []
        }
      ]
    },
    amount_subtotal: 1000,
    amount_total: 1000,
    amount_tax: 0,
    total_details: {
      amount_tax: 0,
      breakdown: {
        taxes: [
          {
            tax: {
              _id: '170d696a-611a-4627-a904-137741027989',
              type: 'VAT',
              rate: '19'
            },
            amount: 0
          },
          {
            tax: {
              rate: 0
            },
            amount: 0
          }
        ],
        recurrences: [
          {
            type: 'recurring',
            billing_period: 'monthly',
            unit_amount_gross: 1013,
            unit_amount_net: 1011,
            amount_subtotal: 1000,
            amount_total: 1000,
            amount_subtotal_decimal: '10',
            amount_total_decimal: '10',
            amount_tax: 0
          }
        ],
        recurrencesByTax: [
          {
            type: 'recurring',
            billing_period: 'monthly',
            amount_total: 0,
            amount_subtotal: 0,
            amount_tax: 0,
            tax: {
              tax: {
                _id: '170d696a-611a-4627-a904-137741027989',
                type: 'VAT',
                rate: '19'
              },
              amount: 0
            }
          },
          {
            type: 'recurring',
            billing_period: 'monthly',
            amount_total: 1000,
            amount_subtotal: 1000,
            amount_tax: 0,
            tax: {
              tax: {
                rate: 0
              },
              amount: 0
            }
          }
        ],
        cashbacks: []
      }
    },
    _schema: 'order',
    _id: '22648a46-2a46-4e53-9da0-b68491ec5874',
    _org: '16246022',
    _created_at: '2025-04-09T06:56:01.306Z',
    _updated_at: '2025-05-07T09:54:59.679Z',
    _title: 'OR-105',
    billing_contact: {
      $relation: [
        {
          entity_id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
          _tags: ['customer']
        }
      ]
    },
    redeemed_promos: [],
    order_number: 'OR-105'
  },
  files: [
    {
      filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
      access_control: 'public-read',
      document_type: 'document',
      _tags: ['Commodity', 'Bestellbestätigung', 'B2C', 'message_attachment'],
      _purpose: [
        'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
        'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
        '6cf77479-becb-408b-a72e-b342bdc87f09',
        '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
      ],
      shared_with_end_customer: true,
      type: 'document',
      public_url:
        'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
      size_bytes: 156303,
      readable_size: '152.64 KB',
      mime_type: 'application/pdf',
      s3ref: {
        bucket: 'epilot-prod-user-content',
        key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
      },
      versions: [
        {
          filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156303,
          readable_size: '152.64 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          }
        }
      ],
      _schema: 'file',
      _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
      _org: '16246022',
      _created_at: '2025-04-04T13:52:22.441Z',
      _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
      _updated_at: '2025-04-04T13:52:24.321Z'
    }
  ],
  relations: [
    {
      _org: '16246022',
      _schema: 'contact',
      last_name: 'Spark',
      first_name: 'Max',
      email: [
        {
          email: 'maxspark360@gmail.com',
          _id: 'HfAOh-AdruvBugA1FbjQf',
          id: 'q37xcz3'
        }
      ],
      payment: [
        {
          _tags: [],
          _id: 'UvxxbZ13mCnwchDZxheL8',
          data: {
            consent: true,
            fullname: 'Max Spark',
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            start_date: '2025-01-01'
          },
          type: 'payment_sepa',
          id: 'eb4tss8'
        },
        {
          _tags: [],
          _id: 'xLMGLijTFmrQilKXlyKU8',
          data: {
            consent: true,
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            fullname: 'Max Spark'
          },
          type: 'payment_sepa',
          id: 'frsd5ru'
        },
        {
          _tags: [],
          _id: 'Eo67TPiGhp7NhOtj6Nc5E',
          data: {
            consent: true,
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030',
            fullname: 'Max Spark'
          },
          type: 'payment_sepa',
          id: 'h1811tg'
        },
        {
          _tags: [],
          _id: '0vEXDJ9JySVANsfaY5wAe',
          data: {
            consent: true,
            fullname: 'Max Spark',
            bic_number: 'INGDDEFFXXX',
            bank_name: 'ING-DiBa',
            iban: 'DE02500105170137075030'
          },
          type: 'payment_sepa',
          id: '1xu838y'
        }
      ],
      birthdate: '1982-09-01',
      address: [
        {
          country: 'DE',
          city: 'Köln',
          _tags: ['delivery', 'billing'],
          additional_info: 'Penthouse',
          street: 'Adolf-Fischer-Str.',
          street_number: '2',
          _id: 'L6sB14Iori1DB0PodxizK',
          postal_code: '50670',
          id: '4ci2bne'
        }
      ],
      phone: [
        {
          phone: '012341234123',
          _id: 'UAa6m3SewPKOWJJXTXC3G',
          id: 'ewodw6a'
        }
      ],
      _id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
      _created_at: '2025-04-04T09:18:17.430Z',
      _title: 'Max Spark',
      consent_email_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: 'maxspark360@gmail.com',
            status: 'active'
          }
        ]
      },
      consent_sms_marketing: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_phone_call: {
        status: 'active',
        identifiers: [
          {
            identifier: '012341234123',
            status: 'active'
          }
        ]
      },
      consent_print_marketing: {
        status: 'unknown',
        identifiers: [
          {
            identifier: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc',
            status: 'unknown'
          }
        ]
      },
      _files: {
        $relation: [
          {
            entity_id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333'
          },
          {
            entity_id: 'a709ab66-7d09-4666-b3b9-9601aad41a70'
          },
          {
            entity_id: '5b03a66f-0385-4533-b780-62052cbfeeaa'
          },
          {
            entity_id: '2e8c7821-2551-41aa-b821-894c197ba420'
          },
          {
            entity_id: 'ef7d78d6-7d65-4892-9266-0f9584ab277b'
          },
          {
            entity_id: 'c0ef117f-9416-4240-8a94-694c6b67511f'
          },
          {
            entity_id: '1e1f456a-926f-43fb-a581-873aa693bbdd'
          },
          {
            entity_id: 'e095ebfc-6845-4851-94c4-cf32c71383b4'
          }
        ]
      },
      first_ecp_login: '2025-04-04T13:56:15.807Z',
      _pending_changes: {},
      journey_actions: [],
      files: [
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156167,
          readable_size: '152.51 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156167,
              readable_size: '152.51 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
          _org: '16246022',
          _created_at: '2025-04-07T07:16:36.872Z',
          _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-07T07:16:38.668Z'
        },
        {
          filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 153036,
          readable_size: '149.45 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 153036,
              readable_size: '149.45 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/2efe448b-6f51-4c49-841e-5e47f4e8406a/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: '5b03a66f-0385-4533-b780-62052cbfeeaa',
          _org: '16246022',
          _created_at: '2025-04-07T07:00:37.276Z',
          _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-07T07:00:38.801Z'
        },
        {
          filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          access_control: 'public-read',
          document_type: 'document',
          _tags: [
            'Commodity',
            'Bestellbestätigung',
            'B2C',
            'message_attachment'
          ],
          _purpose: [
            'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
            'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
            '6cf77479-becb-408b-a72e-b342bdc87f09',
            '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
          ],
          shared_with_end_customer: true,
          type: 'document',
          public_url:
            'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
          size_bytes: 156303,
          readable_size: '152.64 KB',
          mime_type: 'application/pdf',
          s3ref: {
            bucket: 'epilot-prod-user-content',
            key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
          },
          versions: [
            {
              filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
              access_control: 'public-read',
              document_type: 'document',
              _tags: ['Commodity', 'Bestellbestätigung', 'B2C'],
              _purpose: [
                'f7689f6a-1ba4-4926-ab09-1db6a9e16b77',
                'ea91a7f8-9ea6-4432-959e-ee45e1c0b650',
                '6cf77479-becb-408b-a72e-b342bdc87f09',
                '8e04c5fc-191d-4576-90f9-8bbb20ff02a7'
              ],
              shared_with_end_customer: true,
              type: 'document',
              public_url:
                'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
              size_bytes: 156303,
              readable_size: '152.64 KB',
              mime_type: 'application/pdf',
              s3ref: {
                bucket: 'epilot-prod-user-content',
                key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
              }
            }
          ],
          _schema: 'file',
          _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
          _org: '16246022',
          _created_at: '2025-04-04T13:52:22.441Z',
          _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
          _updated_at: '2025-04-04T13:52:24.321Z'
        }
      ],
      language: 'en',
      customer_number: '1234567880',
      salutation: 'Mr.',
      inbetriebnahme: false,
      _updated_at: '2025-06-12T06:03:13.192Z'
    },
    {
      name: 'Strom Flex',
      internal_name: 'Dummy Strom Flex',
      type: 'product',
      active: true,
      description: 'Some description',
      feature: [
        {
          _id: 'qorpTJ5ytdvAoPNqqpvUA',
          _tags: [],
          value: '',
          feature: '100% Ökostrom'
        },
        {
          _id: 'GZ6HbqnWhtkefI5X8ruv3',
          _tags: [],
          value: '',
          feature: 'Erstlaufzeit bis 31.12.2025'
        }
      ],
      price_options: {
        $relation: [
          {
            entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
            _tags: []
          }
        ]
      },
      _schema: 'product',
      _id: '9e757988-e24d-47a3-b376-9985053c1e30',
      _org: '16246022',
      _created_at: '2025-04-09T06:55:34.468Z',
      _updated_at: '2025-04-09T06:55:34.468Z',
      _title: 'Strom Flex'
    }
  ],
  products: [
    {
      name: 'Strom Flex',
      internal_name: 'Dummy Strom Flex',
      type: 'product',
      active: true,
      description: 'Some description',
      feature: [
        {
          _id: 'qorpTJ5ytdvAoPNqqpvUA',
          _tags: [],
          value: '',
          feature: '100% Ökostrom'
        },
        {
          _id: 'GZ6HbqnWhtkefI5X8ruv3',
          _tags: [],
          value: '',
          feature: 'Erstlaufzeit bis 31.12.2025'
        }
      ],
      price_options: [
        {
          _id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
          description: 'Strom Flex',
          internal_description: 'Dummy Strom Flex',
          pricing_model: 'per_unit',
          unit_amount: 0,
          unit_amount_currency: 'EUR',
          unit_amount_decimal: '0.00',
          is_tax_inclusive: true,
          price_display_in_journeys: 'show_price',
          active: true,
          type: 'one_time',
          billing_duration_unit: 'years',
          notice_time_unit: 'months',
          termination_time_unit: 'months',
          renewal_duration_unit: 'months',
          is_composite_price: true,
          price_components: {
            $relation: [
              {
                entity_id: 'fbfd2a6b-8937-4897-848a-f50e50e8e1c4',
                _schema: 'price',
                _tags: []
              },
              {
                entity_id: '79a2a78d-346b-47ed-a0af-43e4f36c9381',
                _schema: 'price',
                _tags: []
              },
              {
                entity_id: '265b52a7-12d3-43aa-81fc-31214dff7289',
                _schema: 'price',
                _tags: []
              }
            ]
          },
          _tags: ['composite'],
          _schema: 'price',
          _org: '16246022',
          _created_at: '2025-04-09T06:54:58.800Z',
          _updated_at: '2025-04-09T07:46:26.026Z',
          billing_period: 'weekly',
          _title: 'Strom Flex',
          billing_duration_amount: 1,
          $relation: {
            entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130',
            _tags: []
          }
        }
      ],
      _schema: 'product',
      _id: '9e757988-e24d-47a3-b376-9985053c1e30',
      _org: '16246022',
      _created_at: '2025-04-09T06:55:34.468Z',
      _updated_at: '2025-04-09T06:55:34.468Z',
      _title: 'Strom Flex',
      _relations: [
        {
          entity_id: '22648a46-2a46-4e53-9da0-b68491ec5874'
        },
        {
          entity_id: '2cd569ad-9689-45a7-90bc-fc06282c6130'
        }
      ],
      _messages: {}
    }
  ],
  crossSellableProducts: {
    products: [],
    prices: [],
    simpleProducts: []
  },
  workflow: [
    {
      version: 2,
      trigger: 'AUTOMATIC',
      lastUpdateTime: '2025-04-07T07:23:20.367Z',
      creationTime: '2025-04-07T07:23:20.367Z',
      assignedTo: [],
      status: 'STARTED',
      wfExecId: 'e5cjfdhsgh2',
      updateEntityAttributes: [],
      selectedClosingReasons: [],
      enableECPWorkflow: true,
      nextOpenStep: {
        entityRefId: 't5183zn3p8i',
        id: 't5183zn3p8i'
      },
      name: 'Wärmepumpe-Anlage B2C',
      taxonomies: [],
      flow: [
        {
          name: 'Prüfungsphase',
          id: 'v3xivbc3ans',
          type: 'SECTION',
          steps: [
            {
              requirements: [],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: 'v3xivbc3ans',
              type: 'STEP',
              entityRefId: 't5183zn3p8i',
              assignedTo: [],
              enabled: true,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Prüfung der Daten auf Richtigkeit und Plausibilität',
              id: 't5183zn3p8i',
              definitionId: 'zzBis4GA',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: 'v3xivbc3ans',
              type: 'STEP',
              entityRefId: '7u2fgxptehl',
              automationConfig: {
                flowId: 'e04f1500-a9a4-482e-a632-e9fd48508a97'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: 'zzBis4GA',
                timePeriod: 'days',
                numberOfUnits: 5,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Nachqualifizierungsjourney spätestens nach 5 Arbeitstagen von Interessent:in nicht ausgefüllt: Reminder E-Mail durch Automatisierung versenden. Wenn Nachqualifizierung ausgefüllt, Schritt überspringen.',
              id: '7u2fgxptehl',
              definitionId: '77dTm7SH',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                enabled: false
              },
              sectionId: 'v3xivbc3ans',
              type: 'STEP',
              entityRefId: 'npgiehpbtng',
              automationConfig: {
                flowId: 'b87be998-49a7-434d-8b43-229b6986b842'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: '77dTm7SH',
                timePeriod: 'days',
                numberOfUnits: 14,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Wenn Reminder rausgeschickt wurde: Warten auf Rückmeldung von Interessent:in. Wenn zum Fälligkeitsdatum weiterhin keine Nachqualifzierung erfolgt ist, Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn Nachqualifizierung ausgefüllt, Schritt überspringen.',
              id: 'npgiehpbtng',
              definitionId: 'AXUHZhEZ',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: 'v3xivbc3ans',
              type: 'STEP',
              entityRefId: 'd84n4uyr5e7',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                description:
                  'Wir haben Ihre Anfrage erhalten und prüfen sie gerade.',
                enabled: true,
                label: 'Prüfungsphase'
              },
              userIds: [],
              name: 'Daten der Nachqualifzierung auf Richtigkeit und Plausibilität prüfen',
              id: 'd84n4uyr5e7',
              definitionId: 'R1ZBPAOU',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '7tPWZ0un',
          status: 'IN_PROGRESS',
          enabled: true
        },
        {
          name: 'Qualifizierungsphase / Vor-Ort-Termin',
          id: 'b6858f58okr',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: 'b6858f58okr',
              type: 'STEP',
              entityRefId: 't3f047mzdyv',
              automationConfig: {
                flowId: '95dfed9a-b49f-418d-b711-a2fffc6883e2'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung nicht erfolgreich - Automatisierung ausführen, um Interessent:in zwecks Rückruf zu kontaktieren. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
              id: 't3f047mzdyv',
              definitionId: 'yN5f0rIA',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Nach dem dritten Kontaktversuch: Frist auf +30 Tage (T+30) setzen. Wenn innerhalb dieser Frist keine Rückmeldung durch Interessent:in Automatisierung ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn innerhalb der Frist eine Kontaktaufnahme erfolgt ist, Schritt überspringen.',
                enabled: true
              },
              sectionId: 'b6858f58okr',
              type: 'STEP',
              entityRefId: 'erha3zazy9s',
              automationConfig: {
                flowId: 'b87be998-49a7-434d-8b43-229b6986b842'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: 'yN5f0rIA',
                timePeriod: 'days',
                numberOfUnits: 1,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Weitere Kontaktaufnahme. Falls Interessent:in wieder nicht erreicht, Aufgabe offen lassen, Frist auf +1 Tag setzen und Automatisierung aus vorherigem Schritt erneut ausführen. Wenn Kontaktaufnahme erfolgreich, Schritt überspringen.',
              id: 'erha3zazy9s',
              definitionId: 'EeCC5puB',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                enabled: true
              },
              sectionId: 'b6858f58okr',
              type: 'STEP',
              entityRefId: 'nblwq5qvudm',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Kontaktaufnahme mit Interessent:in für Terminvereinbarung Vor-Ort-Beratung - Datum in Feld "1. Vor-Ort-Termin" eintragen.',
              id: 'nblwq5qvudm',
              definitionId: '_Y9T46UT',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1deff70-1123-11f0-81ce-455e80ecdcf1',
                name: 'Allgemein - Uploads Vertrieb',
                id: '81148d18-84af-4d70-8889-3675bb2207ce'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Fotos aus dem Vor-Ort-Termin der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".\n                                \nUploadkategorien:\n- Gebäudegrundriss\n- Heizungsraum\n- Heizkörper\n- Aktuelle Heizungsanlage (falls nicht schon eingereicht)\n- Aufstellort innen\n- Standort der Außeneinheit\n- Verbrauchswerte / Stromrechnungen der letzten 3 Jahre (falls nicht schon eingereicht)\n- Zählerschrank\n- Sonstiges\n',
                enabled: true
              },
              sectionId: 'b6858f58okr',
              type: 'STEP',
              entityRefId: 'hbfpbq583a6',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                description:
                  'Für die weitere Planung ist es notwendig das Objekt vor Ort zu besichtigen.',
                enabled: true,
                label: 'Vor-Ort-Terminierung'
              },
              userIds: [],
              name: 'Während des Vor-Ort-Termins: Fehlende Fotos/ Informationen einholen - Fotos über verknüpfte Klickstrecke hochladen.',
              id: 'hbfpbq583a6',
              definitionId: 'xMh0jYAR',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: 'b6858f58okr',
              type: 'STEP',
              entityRefId: 'xgvxd5in3j6',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Opportunity und alle relevanten Entitäten über das Teilen Symbol (oben rechts) mit dem Partner teilen.',
              id: 'xgvxd5in3j6',
              definitionId: 'JMDHcRzK',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'j7eJh3wY',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Prüfungsphase Partner',
          id: 'z1ylaxlx6pa',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Die Terminbestätigung an Interessent:in wird automatisch versandt.',
                enabled: true
              },
              sectionId: 'z1ylaxlx6pa',
              type: 'STEP',
              entityRefId: '1tti24416ni',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Partner: optionale 2. Vor-Ort-Terminvereinbarung - Datum in Feld "2. Vor-Ort-Termin" eintragen.',
              id: '1tti24416ni',
              definitionId: 'c36_ZWe9',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                name: 'Allgemein - Uploads Partner',
                id: 'd9d2d361-e541-4121-bae3-881defee193b'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie den Kostenvoranschlag übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: 'z1ylaxlx6pa',
              type: 'STEP',
              entityRefId: 'g3i55tad2u8',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Partner: KVA Erstellung - KVA über verknüpfte Klickstrecke hochladen.',
              id: 'g3i55tad2u8',
              definitionId: 'j_KdVk98',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '-hj_-Fi3',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'KVA Erstellung inkl. Versand an Interessent:in',
          id: 'lfj21h4scib',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: 'lfj21h4scib',
              type: 'STEP',
              entityRefId: 'mh7pfrwe5eo',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Handwerker-KVA überprüfen und auf Basis des KVA eine Bestellung unter Gruppe "Bestellungen und Angebote" anlegen und speichern.',
              id: 'mh7pfrwe5eo',
              definitionId: 'I_2MFpk_',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Sobald der KVA an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen.',
                enabled: true
              },
              sectionId: 'lfj21h4scib',
              type: 'STEP',
              entityRefId: '095caos385l',
              automationConfig: {
                flowId: 'a5d16486-b1ef-4766-a1c0-a920c9c45da9'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'E-Mail-Vorlage "Wärmepumpe - KVA inkl. Annahme" auswählen, erstellten KVA prüfen und E-Mail versenden.',
              id: '095caos385l',
              definitionId: '8fjgsHao',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: 'lfj21h4scib',
              type: 'STEP',
              entityRefId: 'h34bul6ah2d',
              automationConfig: {
                flowId: '6a46a2c2-ba14-481e-a7d3-1da4f5a4a5ca'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: '8fjgsHao',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'KVA Annahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Falls KVA Annahme bereits erfolgt, Schritt überspringen.',
              id: 'h34bul6ah2d',
              definitionId: 'xoFHz1FG',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'kAdQ_g3h',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Angebotsphase',
          id: '1o9vqvh2avn',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                name: 'Allgemein - Uploads Partner',
                id: 'd9d2d361-e541-4121-bae3-881defee193b'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Heizlastberechnung sowie das Angebot übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: '1o9vqvh2avn',
              type: 'STEP',
              entityRefId: 'hcwmliabkjh',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: Heizlastberechnung durchführen und Erstellung Angebot - beide Dokumente über verknüpfte Klickstrecke hochladen.',
              id: 'hcwmliabkjh',
              definitionId: '8uHdvwLd',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Der ursprüngliche KVA wird ebenfalls als finales Angebot verwendet. Entsprechend müssen etwaige Anpassungen im ursprünglichen KVA vorgenommen werden.',
                enabled: true
              },
              sectionId: '1o9vqvh2avn',
              type: 'STEP',
              entityRefId: 'zphajyec9xn',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Handwerker-Angebot überprüfen und bestehenden KVA unter Gruppe "Bestellungen und Angebote", wenn benötigt, anpassen und speichern.',
              id: 'zphajyec9xn',
              definitionId: 'p3Pgs00f',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen.',
                enabled: true
              },
              sectionId: '1o9vqvh2avn',
              type: 'STEP',
              entityRefId: '0m6ydqtuvcy',
              automationConfig: {
                flowId: 'e39e9229-ec50-4715-9f19-f479ab2c64ac'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                description:
                  'Wir planen aktuell Ihre individuelle Heizungsanlage.',
                enabled: true,
                label: 'Planung der Heizungsanlage'
              },
              userIds: [],
              name: 'Email-Vorlage "Wärmepumpe - Finales Angebot inkl. Angebotsannahme" auswählen, erstelltes Angebot prüfen und E-Mail versenden.',
              id: '0m6ydqtuvcy',
              definitionId: 'OfHwI_qm',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '1o9vqvh2avn',
              type: 'STEP',
              entityRefId: '21z53hls2on',
              automationConfig: {
                flowId: '0b72ca00-06a1-4b64-8406-0484fa841185'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              dynamicDueDate: {
                stepId: 'OfHwI_qm',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Angebotsannahme erfolgt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Wenn "Ja", Schritt überspringen.',
              id: '21z53hls2on',
              definitionId: 'f-kS2-D5',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '1o9vqvh2avn',
              type: 'STEP',
              entityRefId: 'teqqqcz7mf0',
              automationConfig: {
                flowId: 'b87be998-49a7-434d-8b43-229b6986b842'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                description:
                  'Sind Sie mit dem unterbreiteten Angebot zufrieden?',
                enabled: true,
                label: 'Angebotsphase'
              },
              dynamicDueDate: {
                stepId: 'f-kS2-D5',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Angebotsannahme erfolgt? Wenn "Nein", Automatisierungsschritt ausführen, um Interessent:in über Prozessabbruch zu informieren - Prozess abbrechen und Abbruchgrund nennen. Wenn "Ja", Schritt überspringen.',
              id: 'teqqqcz7mf0',
              definitionId: 'BCtBCqmL',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'nkelpCQ7',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Förderung - diese Phase ist nur relevant, wenn Kund:in eine Förderung plant',
          id: '8vrmkrnywue',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: 'cqieaingxfv',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Wenn Planung Förderung "Ja", dann Partner die nächste Aufgabe zuweisen. Wenn Planung Förderung "Nein", dann Schritt überspringen.',
              id: 'cqieaingxfv',
              definitionId: 'XGxUmxcY',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Beauftragung unter Vorbehalt der Förderzusage: \nKund:in hat das Angebot angenommen und möchte eine Förderung beantragen. Damit der Liefer- und Leistungsvertrag für die Beantragung der Fördermittel erstellt werden kann, benötigen wir noch die BzA-Nummer sowie eine kurze Beschreibung des geplanten Sanierungsvorhabens. Bitte übermitteln Sie uns diese Angaben zeitnah.\n',
                enabled: true
              },
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: '1obk6fyrftb',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: BzA (Bestätigung zum Antrag) in Feld "BzA Nummer" eintragen und Sanierungsvorhaben in Feld "Beschreibung Sanierungsvorhaben" kurz beschreiben. Wenn Planung Förderung "Nein", dann Schritt überspringen.',
              id: '1obk6fyrftb',
              definitionId: '4_jGYwMO',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Sobald der LL an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen.',
                enabled: true
              },
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: 'usupybesp7z',
              automationConfig: {
                flowId: 'a3047916-3c81-4a71-adfa-7652eaf27913'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Wenn Planung Förderung "Ja": Email-Vorlage "Wärmepumpe - Übermittlung Liefer- und Leistungsvertrag" (LL) auswählen, erstellten LL prüfen und E-Mail versenden. Wenn Planung Förderung "Nein", dann Schritt überspringen.',
              id: 'usupybesp7z',
              definitionId: 'kMlllOkG',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: 'rk07hz7nr44',
              automationConfig: {
                flowId: '2d5666ae-4d6d-43fc-9171-9108fae4b5d9'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: 'kMlllOkG',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Wenn Planung Förderung "Ja": Hat Interessent:in signierten LL übermittelt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Falls unterschriebener LL vorliegt bzw. Planung Förderung "Nein", Schritt überspringen.',
              id: 'rk07hz7nr44',
              definitionId: 'dpaVvdSQ',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: 'nkgb7zf0wlx',
              automationConfig: {
                flowId: '30805cb3-cd38-4889-a490-ab41d1f0f500'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: 'dpaVvdSQ',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Wenn Planung Förderung "Ja": Hat Interessent:in Status zum Fördermittelantrag übermittelt? Wenn "Nein" Automatisierungsschritt ausführen, um Reminder zu senden. Falls Status Fördermittelbescheid vorliegt bzw. Planung Förderung "Nein", Schritt überspringen.',
              id: 'nkgb7zf0wlx',
              definitionId: 'OelIMKoT',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Sobald das finale Angebot an Interessent:in versandt wurde Automatisierung ausführen, um das Datum der Übermittlung in das entsprechende Attribut zu übertragen (Dabei wird die aktuelle Übermittlung des ursprünglichen ungültigen Angebots überschrieben).',
                enabled: true
              },
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: 'cln3wrnu6qg',
              automationConfig: {
                flowId: 'e39e9229-ec50-4715-9f19-f479ab2c64ac'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              dynamicDueDate: {
                stepId: 'OelIMKoT',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Wenn Planung Förderung "Ja": Sichtung Fördermittelbescheid: Wenn Fördermittelbescheid "Genehmigt", dann Schritt überspringen. Wenn Fördermittelbescheid "Nicht genehmigt" Kontaktaufnahme mit Interessent:in, um weitere Vorgehensweise zu besprechen. Wenn Interessent:in weiterhin Interesse hat, E-Mail-Vorlage "Finales Angebot inkl. Angebotsannahme (bei negativem Förderbescheid)" auswählen, erstelltes Angebot prüfen und E-Mail versenden. Wenn kein Interesse, Prozess abbrechen. Wenn Planung Förderung "Nein", Schritt überspringen.',
              id: 'cln3wrnu6qg',
              definitionId: 'dlEHgQZS',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: '8vrmkrnywue',
              type: 'STEP',
              entityRefId: '92avp2lrdi8',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                description:
                  'Für die weitere Bearbeitung benötigen wir Details zur Förderung.',
                enabled: true,
                label: 'Details zur Förderung'
              },
              dynamicDueDate: {
                stepId: 'dlEHgQZS',
                timePeriod: 'days',
                numberOfUnits: 14,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Falls 2. Angebotsannahme erfolgt, Schritt überspringen. Falls 2. Angebotsannahme nicht erfolgt, Prozess abbrechen.',
              id: '92avp2lrdi8',
              definitionId: '_FaR6eV3',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'Sfl3AtnQ',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Vorbereitung Bereitstellung',
          id: '9ax62mizqzn',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1deff70-1123-11f0-81ce-455e80ecdcf1',
                name: 'Allgemein - Uploads Vertrieb',
                id: '81148d18-84af-4d70-8889-3675bb2207ce'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die 1. Anzahlungsrechnung übermitteln können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                enabled: true
              },
              sectionId: '9ax62mizqzn',
              type: 'STEP',
              entityRefId: '2yufdo3tqop',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'ERP: 1. Anzahlungsrechnung erstellen: Rechnungsversand an Kund:in (1. Rechnung - Anzahlung) - Anzahlungsrechnung über verknüpfte Klickstrecke hochladen.',
              id: '2yufdo3tqop',
              definitionId: 'dd7i4fmj',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'AUTOMATION',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Mit der Ausführung der Automatisierung wird das Datum der Beauftragung des Partners in das entsprechende Feld übertragen. Die Beauftragung des Partners ist in den weiteren informationen im nächsten Schritt vermerkt.',
                enabled: true
              },
              sectionId: '9ax62mizqzn',
              type: 'STEP',
              entityRefId: '3ibcrapnyjl',
              automationConfig: {
                flowId: '997ec8f3-aa6e-4879-aa83-ae6f443b2c35'
              },
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              dynamicDueDate: {
                stepId: 'dd7i4fmj',
                timePeriod: 'days',
                numberOfUnits: 7,
                actionTypeCondition: 'STEP_CLOSED'
              },
              userIds: [],
              name: 'Wiedervorlage: Zahlung eingegangen? Wenn "Ja", Automatisierungsschritt ausführen - Beauftragung des Partners über nachfolgende Aufgabe. Wenn "Nein", Kontaktaufnahme mit Kund:in und neue Frist auf T+7 setzen.',
              id: '3ibcrapnyjl',
              definitionId: 'G8Y9cTif',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '65Dt7ZS9',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Installation inkl. Fertigstellung Partner',
          id: '133sfkbeyjh',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Finale Beauftragung für Installation der Wärmepumpe: \nKund:in hat das Angebot angenommen. Für die Terminvereinbarung zur Installation, sowie die weitere interne Organisation bitte die Widerrufsfrist beachten (siehe Feld Ende Widerrufsfrist)!\n',
                enabled: true
              },
              sectionId: '133sfkbeyjh',
              type: 'STEP',
              entityRefId: 'em6rc9yw73x',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: Terminvereinbarung und Baubeginn (nach Widerrufsfrist) - Datum Baubeginn in Feld "Baubeginn" eintragen.',
              id: 'em6rc9yw73x',
              definitionId: 'bTVIdKd5',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              sectionId: '133sfkbeyjh',
              type: 'STEP',
              entityRefId: 'ewxj9pvuafn',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: Wärmepumpe wurde beim Netzbetreiber angemeldet, sowie ggf. erforderlicher Zähler.',
              id: 'ewxj9pvuafn',
              definitionId: 'g3eVTm5t',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                name: 'Allgemein - Uploads Partner',
                id: 'd9d2d361-e541-4121-bae3-881defee193b'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie das Abnahmeprotokoll der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: '133sfkbeyjh',
              type: 'STEP',
              entityRefId: '3vwopy708q7',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Partner: Baumaßnahmen wurden fertiggestellt und abgenommen - Datum der Fertigstellung in Feld "Fertigstellung" eintragen - Abnahmeprotokoll über verknüpfte Klickstrecke hochladen.',
              id: '3vwopy708q7',
              definitionId: 'fsSeQWuu',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'fsSeQWuu'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                name: 'Allgemein - Uploads Partner',
                id: 'd9d2d361-e541-4121-bae3-881defee193b'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'Hinweis: Obligatorisch für den Fall, dass der Kund:in die Förderung gewährt wurde.\nIn diesem Schritt ist eine Klickstrecke integriert, in der Sie die Bestätigung der Durchführung (BnD) der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".\n',
                enabled: true
              },
              sectionId: '133sfkbeyjh',
              type: 'STEP',
              entityRefId: '5tngmzk5ksd',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              userIds: [],
              name: 'Partner: Bestätigung nach Durchführung (BnD) wurde Kund:in ausgestellt.',
              id: '5tngmzk5ksd',
              definitionId: 'An4yz9pM',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'fsSeQWuu'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'An4yz9pM'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                name: 'Allgemein - Uploads Partner',
                id: 'd9d2d361-e541-4121-bae3-881defee193b'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Dokumentation der Errichtung und der Inbetriebnahme der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: '133sfkbeyjh',
              type: 'STEP',
              entityRefId: 'w9rgqj2q86c',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: true,
                label: 'Installation inkl. Fertigstellung'
              },
              userIds: [],
              name: 'Partner: Dokumentation der Errichtung und der Inbetriebnahme - Dokumente über verknüpfte Klickstrecke hochladen.',
              id: 'w9rgqj2q86c',
              definitionId: 'MyqzJdfC',
              status: 'UNASSIGNED',
              manuallyCreated: false
            },
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'fsSeQWuu'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'An4yz9pM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'MyqzJdfC'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1fc2460-1123-11f0-8026-a3a76ed9dbd7',
                name: 'Allgemein - Uploads Partner',
                id: 'd9d2d361-e541-4121-bae3-881defee193b'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Partner".',
                enabled: true
              },
              sectionId: '133sfkbeyjh',
              type: 'STEP',
              entityRefId: 'youefa1pcux',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: false
              },
              userIds: [],
              name: 'Partner: Schlussrechnung erstellen - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
              id: 'youefa1pcux',
              definitionId: 'PnKp6bGK',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: 'OgeUHFyc',
          status: 'OPEN',
          enabled: true
        },
        {
          name: 'Abschluss',
          id: 'jkxsyxkletj',
          type: 'SECTION',
          steps: [
            {
              requirements: [
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'zzBis4GA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '77dTm7SH'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'AXUHZhEZ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'R1ZBPAOU'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'yN5f0rIA'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'EeCC5puB'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_Y9T46UT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xMh0jYAR'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'JMDHcRzK'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'c36_ZWe9'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'j_KdVk98'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'I_2MFpk_'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8fjgsHao'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'xoFHz1FG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '8uHdvwLd'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'p3Pgs00f'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OfHwI_qm'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'f-kS2-D5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'BCtBCqmL'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'XGxUmxcY'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '4_jGYwMO'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'kMlllOkG'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dpaVvdSQ'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'OelIMKoT'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dlEHgQZS'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: '_FaR6eV3'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'dd7i4fmj'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'G8Y9cTif'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'bTVIdKd5'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'g3eVTm5t'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'fsSeQWuu'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'An4yz9pM'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'MyqzJdfC'
                },
                {
                  type: 'STEP',
                  condition: 'CLOSED',
                  definitionId: 'PnKp6bGK'
                }
              ],
              startedTime: '2025-04-07T07:23:20.367Z',
              journey: {
                journeyId: 'c1deff70-1123-11f0-81ce-455e80ecdcf1',
                name: 'Allgemein - Uploads Vertrieb',
                id: '81148d18-84af-4d70-8889-3675bb2207ce'
              },
              created: '2025-04-07T07:23:20.367Z',
              executionType: 'MANUAL',
              assignedToInProgress: '-',
              description: {
                value:
                  'In diesem Schritt ist eine Klickstrecke integriert, in der Sie die Schlussrechnung der Opportunity hinzufügen können. Klicken Sie dafür auf "Allgemein - Uploads Vertrieb".',
                enabled: true
              },
              sectionId: 'jkxsyxkletj',
              type: 'STEP',
              entityRefId: 'b1mwlvpsmzc',
              assignedTo: [],
              enabled: false,
              lastUpdated: '2025-04-07T07:23:20.367Z',
              ecp: {
                enabled: true,
                label: 'Abschluss'
              },
              userIds: [],
              name: 'ERP: Schlussrechnung an Kund:in senden - Schlussrechnung über verknüpfte Klickstrecke hochladen.',
              id: 'b1mwlvpsmzc',
              definitionId: '76QWWDEa',
              status: 'UNASSIGNED',
              manuallyCreated: false
            }
          ],
          assignedTo: [],
          definitionId: '8vvcDG0J',
          status: 'OPEN',
          enabled: true
        }
      ],
      configuredClosingReasonSnapshot: [
        {
          title: 'Wirtschaftlichkeit',
          id: '4vDdM4Ta5TIiK2ZLQFv2M'
        },
        {
          title: 'Entscheidung für Mitbewerber',
          id: 'uUW4-bIsq5Ozm3xcmIRC8'
        },
        {
          title: 'Zeitlich nicht passend',
          id: 'ZdbD_S25HvYBZfOSX4Z1e'
        },
        {
          title: 'Keine Angabe von Gründen',
          id: 'nH_sgr1zfOtV13maXhScO'
        },
        {
          title: 'Kein Interesse nach negativem Fördermittelbescheid',
          id: '0klnIumPiUKeLXWoRU0D_'
        },
        {
          title: 'Keine Rückmeldung vom Kunden',
          id: '08xZ-Ex6VxT6fD_tZO-5E'
        },
        {
          title: 'Zu lange Wartezeit',
          id: 'lm9Rp2kd8i94PfJpnQi7-'
        },
        {
          title: 'Kosten zu hoch',
          id: 'eq8g6NXYOmqkWdh2EvieE'
        }
      ],
      contexts: [
        {
          schema: 'contact',
          title: 'Max Spark',
          id: '6d0ce8f8-8b03-4bda-b22b-c9b829bb08fc'
        },
        {
          schema: 'opportunity',
          title: 'OP-102 - Wärmepumpe Teil 1 (Leadgenerierung)',
          id: 'bc6609ed-6b0c-4ad3-b6d4-42e72b68521f'
        }
      ],
      orgId: '16246022',
      definitionId: 'wfiHJi3ZfB',
      id: 'e5cjfdhsgh2'
    }
  ],
  journey_actions: []
}
